import type {Result, UseCase} from 'framework';
import type {DashboardError} from '../../domain/errors';
import type {MealDetail} from '../../domain/meal-detail';
import type {MealId} from '../../domain/meal-id.value-object';
import type {DashboardRepository} from '../ports/dashboard.repository';

export interface GetMealDetailInput {
  readonly mealId: MealId;
}

export class GetMealDetail implements UseCase<[GetMealDetailInput], MealDetail> {
  constructor(private readonly dashboardRepository: DashboardRepository) {}

  execute(input: GetMealDetailInput): Promise<Result<MealDetail, DashboardError>> {
    return this.dashboardRepository.getMealDetail({mealId: input.mealId});
  }
}
